module.exports = __webpack_public_path__ + "static/media/financepic6@3x.3155b04c.png";